export default __webpack_public_path__ + "static/media/R.8af01add.png";